import { render, staticRenderFns } from "./EducationTest.vue?vue&type=template&id=2f84635d&scoped=true"
import script from "./EducationTest.vue?vue&type=script&lang=js"
export * from "./EducationTest.vue?vue&type=script&lang=js"
import style0 from "./EducationTest.vue?vue&type=style&index=0&id=2f84635d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f84635d",
  null
  
)

export default component.exports